import { boxEntity } from "../domain/entities/box";
import { boxConsumableEntity } from "../domain/entities/box_consumable";
import { BoxContract } from "../domain/contracts/box_contract";
import http from "../../../plugins/http-common"

export const HttpBoxRepository = {
  ...BoxContract,
  model: boxEntity,
  model_consumable: boxConsumableEntity,

  async index() {
    const res = await http.get('boxes');
    
    return res.data.data.map(item => item.attributes);
  },

  async box_consumables_index(){
    const res = await http.get('consumables?consumable_type=Box');

    return res;
  },
};